import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { icons } from '@/components/Base/Lucide';

export interface Menu {
  icon: keyof typeof icons;
  title: string;
  badge?: number;
  pathname?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | string>;
}

const initialState: SideMenuState = {
  menu: [
    {
      icon: 'LayoutDashboard',
      pathname: '/',
      title: 'Dashboard',
    },
    {
      icon: 'Users',
      pathname: '/ambassador',
      title: 'Ambassador',
    },
  ],
};

export const sideMenuSlice = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {},
});

export const selectSideMenu = (state: RootState) => state.sideMenu.menu;

export default sideMenuSlice.reducer;
